import React, { useState, useEffect } from "react";
import CustomTitle from "../Custom/CustomTitle";
import LiveMap from "./LiveMap";
import LiveUserTimeline from "./LiveUserTimeline";
import Header from "../Header/Header";
import LiveStatusMember from "./LiveStatusMember";
import CustomSelect from "../../components/common/CustomSelect";
import SingleUserLiveMap from "./SingleUserLiveMap";
import teamServices from "../Services/teamServices";
import liveTrackService from "../Services/liveTrackService";
import UserServices from "../Services/UserServices";
import { formatDate } from "../../components/Constant/Constant";
import { ToastContainer } from "react-toastify";
import TeamService from "../../GlobalSetupComponents/Services/TeamService";
import { department } from "../../utils/storage";
import { salesDepartmentLabel } from "../../GlobalSetupComponents/Enum/DepartmentEnum";

const LiveTrackingPage = () => {
  const [isLiveTracking, setIsLiveTracking] = useState(false);
  const [teamList, setTeamList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userId, setUserId] = useState(null);
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const [trackingData, setTrackingData] = useState([]);
  const [isNavigated, setIsNavigated] = useState(false);

  const [selectedPoint, setSelectedPoint] = useState(null);
  const [propertyLocations, setPropertyLocations] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState(null);

  const fetchTeamList = async () => {
    try {
      const response = await TeamService.getDepartmentTeamList({
        department : salesDepartmentLabel
      })
    
      if (response && response.data) {
        setTeamList(response.data);
        const teams = response.data || [];
        setTeamList(teams);
        if (teams.length > 0) {
          setSelectedTeam({ value: teams[0].value, label: teams[0].label });
        }
      }
    } catch (error) {
      console.error("Error fetching team list:", error);
    }
  };
  useEffect(() => {
    fetchTeamList();
  }, []);

  const getDistanceFromLatLng = (lat1, lng1, lat2, lng2) => {
    const R = 6371e3; // meters
    const toRad = (deg) => (deg * Math.PI) / 180;
  
    const φ1 = toRad(lat1);
    const φ2 = toRad(lat2);
    const Δφ = toRad(lat2 - lat1);
    const Δλ = toRad(lng2 - lng1);
  
    const a =
      Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) *
      Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  
    return R * c; // meters
  };
  
  

  const enrichTrackingWithProperties = (trackingData, propertyLocations) => {
    // Track the most recent property for the user
    let currentProperty = null;
    let lastPropertyTime = null;

    return trackingData.map((point, index) => {
      if (!point.geoPoint || point.geoPoint.length !== 2) return point;

      const [lat, lng] = point.geoPoint;

      // Find all nearby properties within 50 meters
      const nearbyProperties = propertyLocations
        .map((prop) => {
          const [propLat, propLng] = prop.geoPoint;
          const distance = getDistanceFromLatLng(lat, lng, propLat, propLng);
          return {
            ...prop,
            distance: distance
          };
        })
        .filter(prop => prop.distance <= 50)
        .sort((a, b) => a.distance - b.distance); // Sort by closest distance

      // If user is near a property
      if (nearbyProperties.length > 0) {
        const closestProperty = nearbyProperties[0];
        
        // Update current property only if it's different from the last one
        // or if this is the first property encounter
        if (!currentProperty || currentProperty.id !== closestProperty.id) {
          currentProperty = closestProperty;
          lastPropertyTime = point.time;
        }

        return {
          ...point,
          propertyName: currentProperty.propertyName,
          propertyId: currentProperty.id,
          isNearProperty: true,
          distanceToProperty: Math.round(closestProperty.distance)
        };
      } else {
        // User is not near any property
        // Keep the last property info if user was recently at a property
        // Clear property info after some time or distance
        const shouldClearProperty = currentProperty && (
          // Clear if more than 10 minutes have passed since last property visit
          index > 10 || // or after 10 tracking points
          (point.time && lastPropertyTime && 
           new Date(`1970/01/01 ${point.time}`) - new Date(`1970/01/01 ${lastPropertyTime}`) > 10 * 60 * 1000)
        );

        if (shouldClearProperty) {
          currentProperty = null;
          lastPropertyTime = null;
        }

        return {
          ...point,
          propertyName: currentProperty ? currentProperty.propertyName : null,
          propertyId: currentProperty ? currentProperty.id : null,
          isNearProperty: false,
          distanceToProperty: null
        };
      }
    });
  };
  

  const fetchTrackingPoints = async (userId, date) => {
    try {
      const response = await liveTrackService.getLiveTrackSingle(userId, date);
  
      if (response && response.data) {
        // Extract the tripDetails array
        const trackingPoints = response.data?.tripDetails || [];
  
        const enriched = enrichTrackingWithProperties(trackingPoints, propertyLocations);
  
        // Keep both enriched tripDetails + meta info (date, battery, etc.)
        setTrackingData({
          ...response.data,
          tripDetails: enriched
        });
  
        console.log("Enriched Tracking Data:", enriched);
      }
    } catch (error) {
      console.error("Error fetching tracking points:", error);
      setTrackingData([]);
      return [];
    }
  };
  
  

  const fetchSelectedTeamUsers = async () => {
    try {
      const response = await teamServices.getGeoLocationTeamMembers(
        selectedTeam.value
      );

      if (response && response.data) {
        setUserList(response.data || []);
        if(!isNavigated){
          if (response.data.length > 0) {
            setSelectedUser({
              value: response.data[0].value,
              label: response.data[0].label,
            });
          }
        }
        
      }
    } catch (error) {
      console.error("Error fetching selected team users:", error);
    }
  };

  useEffect(() => {
    if (isLiveTracking && selectedTeam) {
      fetchSelectedTeamUsers();
    }
  }, [selectedTeam, isLiveTracking]);

  useEffect(() => {
    if (isLiveTracking && selectedUser) {
      fetchTrackingPoints(selectedUser.value, date);
    }
  }, [selectedUser, date, isLiveTracking]);

  const fetchPropertyLocations = async () => {
    try {
      const response = await liveTrackService.getPropertyLocations();
      if (response && response.data) {
        setPropertyLocations(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching property locations:", error);
    }
  
  };
    useEffect(() => {
      fetchPropertyLocations();
    }, []);
  

  const handleNavigationUserLiveTracking = (team, user) => {
  
    setSelectedTeam(team);
    setSelectedUser(user);
    setIsLiveTracking(true);
    setIsNavigated(true);

  }

  return (
    <div className="min-h-screen bg-appGrayBackground flex flex-col">
      <Header />
      <ToastContainer/>
      <div className="flex-1 flex flex-col px-6 pt-28 pb-10">
        {/* Header Section */}
        <div className="flex justify-between items-center mb-8 flex-shrink-0">
          <div className="flex items-center gap-4">
            <CustomTitle title={"Live Tracking"} textColor={"primary"} />
            <div className="relative bg-slate-200 p-1 w-full max-w-[380px] rounded-[10px] flex justify-between items-center overflow-hidden">
              <div
                className="absolute top-1 bottom-1 left-1 w-[180px] bg-white rounded-[10px] shadow-soft-all transition-transform duration-300"
                style={{
                  transform: isLiveTracking
                    ? "translateX(190px)"
                    : "translateX(0px)",
                }}
              ></div>

              <div
                className={`w-[200px] z-10 text-center cursor-pointer py-2 font-medium transition-all duration-300 ${
                  !isLiveTracking ? "text-customGreen" : "text-gray-700"
                }`}
                onClick={() => {
                  setIsLiveTracking(!isLiveTracking);
                  setIsNavigated(false);
                }}
              >
                Live Tracking
              </div>

              <div
                className={`w-[200px] z-10 text-center cursor-pointer py-2 font-medium transition-all duration-300 ${
                  isLiveTracking ? "text-customGreen" : "text-gray-700"
                }`}
                onClick={() => {
                  setIsLiveTracking(!isLiveTracking);
                  setIsNavigated(false);
                }}
              >
                Timeline Tracking
              </div>
            </div>
          </div>
          <div className="flex items-center gap-4">
            {isLiveTracking && (
              <div className="flex items-center gap-2 bg-white rounded-lg px-3 py-2 border border-gray-200">
                <div className="w-52">
                <CustomSelect
                  isClearable={false}
                  placeholder="Select Team"
                  options={teamList}
                  onChange={(option) => {
                    setSelectedTeam(option);
                  }}
                  value={selectedTeam}
                />
                </div>
                <div className="w-52">
                <CustomSelect
                  placeholder="Select User"
                  isClearable={false}
                  options={userList}
                  onChange={(option) => {
                    setSelectedUser(option);
                  }}
                  value={selectedUser}
                />
                </div>
                <div className="w-52">
                <CustomSelect
             
                  placeholder="Select Property"
                  options={propertyLocations.map((prop) => ({
                    value: prop.id,
                    label: prop.propertyName
                  }))}
                  onChange={(option) => {
                    setSelectedProperty(option);
                  }}
                  value={selectedProperty}
                />
                </div>
                
             
                
                <input
                  type="date"
                  value={date}
                  max={new Date().toISOString().split("T")[0]}
                  onChange={(e) => setDate(e.target.value)}
                  className="bg-white border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            )}
          </div>
        </div>

        {/* Main Content */}
        <div className="flex-1 min-h-0">
          <div className="grid lg:grid-cols-12 gap-6 h-full">
            <div className="lg:col-span-8 min-h-0">
              <div className="h-full">
                {!isLiveTracking ? (
                  <div className="bg-white p-4 rounded-lg shadow-sm h-full flex flex-col">
                 
                  <div className="w-full mb-3 flex items-center justify-end gap-2 flex-shrink-0">
                    <label className="text-sm font-medium text-gray-600">Team:</label>
                    <div className="w-64">
                      <CustomSelect
                        isClearable={false}
                        placeholder="Select Team"
                        options={teamList}
                        onChange={(option) => {
                          setSelectedTeam(option);
                        }}
                        value={selectedTeam}
                      />
                    </div>
                  </div>
                
                
                  <div className="flex-1 min-h-0">
                    <LiveMap selectedTeam={selectedTeam} propertyLocationData={propertyLocations} />
                  </div>
                </div>
                
                ) : (
                  <div className="bg-white p-2 rounded-lg shadow-sm h-full">
            <SingleUserLiveMap data={trackingData} selectedPoint={selectedPoint} propertyLocationData={propertyLocations} />
                  </div>
                )}
              </div>
            </div>

            <div className="lg:col-span-4 min-h-0">
              <div className="bg-white p-2 rounded-lg shadow-sm h-full">
                {!isLiveTracking ? (
                  <LiveStatusMember  onNavigationUserTracking={handleNavigationUserLiveTracking}  />
                ) : (  
                  <LiveUserTimeline
                  data={trackingData}
                  userName={selectedUser?.label}
                  onPointClick={setSelectedPoint}
                 selectedProperty={selectedProperty}
                />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveTrackingPage;